import React, { useState } from 'react'

const SearchBox = (props) => {
    const [searchTerm, setSearchTerm] = useState('')

    const tableRef = props.tableRef

    const handleChange = (e) => {
        const term = e.target.value
        setSearchTerm(term)
        if (tableRef.current) {
          tableRef.current.dt().search(term).draw()
        }
    }

    const handleClear = () => {
        const term = ''
        setSearchTerm(term)
        if (tableRef.current) {
          tableRef.current.dt().search(term).draw()
        }
    }
    
    const clear = searchTerm === '' ? null : (<span title="Clear" className="searchbox-clear" onClick={handleClear}>&times;</span>)
    
    return (
        <div className="col-sm-6 m-b-xs">
            <span className="text-input-wrapper searchbox-wrapper" key="wrapper">
                <span title="Search" className="searchbox-search" key="search">
                    <i className="fa fa-search"></i>
                </span>
                <input
                    key="input"
                    className="input-sm form-control input-s-sm inline searchbox-input"
                    type="search"
                    id="searchbox"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(event) => handleChange(event)}
                />
                {clear}
            </span>
        </div>
    )
};

export default SearchBox
